import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getDataAccuracyTasks(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/tasks/?type=Data Anomaly`,
    oauthTokenHeader
  );
}

function getDataAccuracyByWebsiteOrDimensionOrOrganization(
  queryId: any,
  oauthTokenHeader: any,
  type: any,
  website_shared_uids: string[] = [],
  dimensions: string[] = []
) {
  // Create query parameters
  const queryParams = new URLSearchParams();
  queryParams.append("type", type);

  // Add multiple dimension parameters
  dimensions.forEach((dimension) => {
    queryParams.append("dimension", dimension);
  });

  // Add multiple website_shared_uid parameters
  website_shared_uids.forEach((uid) => {
    queryParams.append("website_shared_uid", uid);
  });

  // Construct the URL
  const url = `${apiUrl}/biz_layer_query/run/${queryId}/?${queryParams.toString()}`;

  return fetchWrapper.get(url, oauthTokenHeader);
}

function getAllDimensions(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/dimensions/`,
    oauthTokenHeader
  );
}

function getDataAccuracyTask(oauthTokenHeader: any, task_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/tasks/${task_shared_uid}/`,
    oauthTokenHeader
  );
}

function updateDataAccuracyTask(oauthTokenHeader: any, data: any) {
  return fetchWrapper.patch(
    `${apiUrl}/utilities/tasks/`,
    data,
    oauthTokenHeader
  );
}

function updateDataAccuracyTaskSingle(
  oauthTokenHeader: any,
  data: any,
  task_shared_uid: any
) {
  return fetchWrapper.put(
    `${apiUrl}/utilities/tasks/${task_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function postDataAccruancyComment(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any
) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/comments/${object_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function getAllUsers(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/admin/users/?active_only=True/`,
    oauthTokenHeader
  );
}

function getComments(oauthTokenHeader: string, object_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/comments/${object_shared_uid}/`,
    oauthTokenHeader
  );
}

function postComments(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any
) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/comments/${object_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function putComments(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any
) {
  return fetchWrapper.put(
    `${apiUrl}/utilities/comments/${object_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}
function uploadFile(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any
) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/file/${object_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function getFiles(oauthTokenHeader: string, object_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/file/${object_shared_uid}/`,
    oauthTokenHeader
  );
}

function getBizLayerQuery(oauthTokenHeader: any, queryId: any) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/${queryId}/`,
    oauthTokenHeader
  );
}

function getTasksByTaskStructureSharedUid(
  oauthTokenHeader: string,
  website_shared_uid: string | string[], // accept single or multiple
  task_structure_shared_uid: string
) {
  // normalize to array
  const websiteIds = Array.isArray(website_shared_uid)
    ? website_shared_uid
    : [website_shared_uid];

  // build query string
  const params = new URLSearchParams();
  websiteIds.forEach((id) => params.append("website_shared_uid", id));
  params.append("task_structure_shared_uid", task_structure_shared_uid);

  return fetchWrapper.get(
    `${apiUrl}/utilities/tasks/?${params.toString()}`,
    oauthTokenHeader
  );
}

export const dataAccuracyService = {
  getDataAccuracyTasks,
  getDataAccuracyTask,
  updateDataAccuracyTask,
  updateDataAccuracyTaskSingle,
  postDataAccruancyComment,
  getAllUsers,
  getComments,
  postComments,
  putComments,
  uploadFile,
  getFiles,
  getDataAccuracyByWebsiteOrDimensionOrOrganization,
  getAllDimensions,
  // new
  getTasksByTaskStructureSharedUid,
  getBizLayerQuery,
};
